





























































































import { defineComponent, computed, ref, onUnmounted } from '@vue/composition-api';
import Login from '@/renderer/components/login/components/index.vue';
import LoginAnimation from '@/renderer/components/login/components/loginAnimation.vue';
import switchOrg from '@/renderer/components/user/components/switchOrg.vue';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import smh, { SMH } from '@/renderer/scripts/smh';
import { openDevTools } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import user from '@/renderer/scripts/utils/user';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
const oauth2Message = [
  {
    authscope: [
      {
        interfaceScope: ['FILE.ALL'],
        label: i18n_t('文件基本操作权限（如上传、下载、删除、移动、复制等）'),
      },
      {
        interfaceScope: ['FILE.UPLOAD'],
        label: i18n_t('文件基本操作权限（如上传）'),
      },
    ],
  },
];
export default defineComponent({
  components: {
    Login,
    LoginAnimation,
    switchOrg,
    SettingDialog,
  },
  setup(props, context) {
    const vm = context.root;
    const store = context.root.$store;
    const thisYear = new Date().getFullYear();

    // 查询参数
    const showInPc = computed(() => !store.getters.isMobile && !store.getters.isMobileStyle);
    const showSetting = ref(false);
    const isOauth = true; // 固定为true
    const oauthStep = ref(1);
    // 用户授权过的企业信息，step 2->3被赋值；再3->2被清空
    const authorizedOrgInfo = ref<CoFile.OrgItem | null>(null);
    const showSwitchOrg = ref(false);
    const team = ref(false);
    const group = ref(false);
    const personal = ref(false);
    const message = ref(i18n_t('文件基本操作权限（如上传、下载、删除、移动、复制等）'));

    const loginLoading = () => {
      let timer: any = setTimeout(() => {
        store.commit('setLoginingMask', false);
        clearTimeout(timer);
        timer = null;
      }, 500);
    };

    const methods = {
      // 账号验证成功（user内部不触发选择企业）后执行
      verified() {
        tips.success(i18n_t('登录成功'));
        oauthStep.value = 2;
        showSwitchOrg.value = true;
        loginLoading();
      },
      // 菜单，弹出devtools
      clickCopyRight(e: MouseEvent) {
        openDevTools(e);
      },
      // 响应托盘菜单消息
      onTrayMenuEvent(e: Event, params: any) {
        const { event } = params;
        switch (event) {
          case 'update':
            ipc.emit(ipc.RENDERER_EVENTS_MAP.CHECK_UPDATE);
            break;
          case 'setting':
            showSetting.value = true;
            break;
          default:
            break;
        }
      },
      async authorizedOrg(orgInfo: CoFile.OrgItem) {
        const { app_id } = vm.$route.query;
        try {
          if (app_id !== null) {
            const oauthInfoParams = { appId: app_id as string };
            // 根据接口返回的authScope信息展示对应的文案
            const { data }: { data: SMH.OauthInfoData } = await smh.userAPI.getOauthInfo(oauthInfoParams);
            const { appName, interfaceScopes } = data;
            if (appName && interfaceScopes) {
              oauth2Message.forEach(item => {
                item.authscope.forEach(scopeItem => {
                  if (scopeItem.interfaceScope.toString() === interfaceScopes.toString()) {
                    message.value = scopeItem.label;
                  }
                });
              });
              // 选择企业后查询是否有个人空间
              const { data } = await smh.userAPI.hasPersonalSpace({
                organizationId: orgInfo.id,
              });
              store.commit('SET_PERSONAL_SPACE', data.hasPersonalSpace); // 登录成功立即保存，以便在保存网盘处，及时判断显示对应空间
            }
          }
        } catch (e: MsgError) {
          tips.error(e, 500);
        }
        oauthStep.value = 3;
        authorizedOrgInfo.value = orgInfo;
      },
      async authroize() {
        const { app_id, redirect_uri, scope, state, oauth_state } = vm.$route.query;
        if (authorizedOrgInfo?.value) {
          const { libraryId, id: organizationId } = authorizedOrgInfo.value;
          const directoryScopes: SMH.AuthItem[] = [];
          if (personal.value === true) {
            directoryScopes.push({
              libraryId,
              spaceTag: SMH.SpaceTag.personal,
              withAllSpace: true,
            });
          }
          if (team.value === true) {
            directoryScopes.push({
              libraryId,
              spaceTag: SMH.SpaceTag.team,
              withAllSpace: true,
            });
          }
          if (group.value === true) {
            directoryScopes.push({
              libraryId,
              spaceTag: SMH.SpaceTag.group,
              withAllSpace: true,
            });
          }
          try {
            const stateStr = oauth_state || state;
            const {
              data,
            }: {
              data: SMH.OauthData;
            } = await smh.userAPI.getOauthCode({
              directoryScopes,
              organizationId,
              appId: String(app_id),
              redirectUri: String(redirect_uri),
              scope: String(scope),
              state: String(stateStr),
            });
            if (data.redirectUriWithCode) {
              tips.success(i18n_t('授权成功，正在跳转'));
              // 这里没有完成登录，上报的公共参数需要自取
              const { isNewUser, userId } = user.getUserInfo();
              reporter.report('hiflow_authorize_success', {
                is_new_user: isNewUser,
                user_id: `${userId}`,
                org_id: `${organizationId}`,
                channel_source: 'hiflow',
              });
              setTimeout(() => {
                dispatchRouter(`${data.redirectUriWithCode}`, 'location');
              }, 500);
            } else {
              tips.error(i18n_t('授权失败'));
            }
          } catch (e: MsgError) {
            tips.error(e, 500);
          }
        }
      },
      changeVal(option: string) {
        switch (option) {
          case 'personal':
            personal.value = !personal.value;
            break;
          case 'group':
            group.value = !group.value;
            break;
          case 'team':
            team.value = !team.value;
            break;
          default:
            break;
        }
      },
      afterLogout() {
        oauthStep.value = 1;
      },
    };
    user.on('verified', methods.verified);
    user.on('after-logout', methods.afterLogout);
    ipc.on(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    onUnmounted(() => {
      user.off('verified', methods.verified);
      user.off('after-logout', methods.afterLogout);
      ipc.off(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    });
    return {
      thisYear,
      showInPc,
      isOauth,
      oauthStep,
      showSwitchOrg,
      team,
      group,
      personal,
      message,
      showSetting,
      authorizedOrgInfo,
      ...methods,
    };
  },
});
